if (!customElements.get('product-accordion')) {
  customElements.define('product-accordion', class ProductAccordion extends HTMLElement {
    connectedCallback() {
      document.querySelectorAll('product-accordion').forEach((el) => {
        if (el !== this) el.remove();
      });

      if (!this.originalPlacementMarker && this.parentNode) {
        this.originalPlacementMarker = document.createComment('product-accordion-original-placement');
        this.parentNode.insertBefore(this.originalPlacementMarker, this);
      }

      if (!this.sourceSectionWrapper) {
        this.sourceSectionWrapper = this.closest('.shopify-section');
      }

      if (!this.desktopMediaQuery) {
        this.desktopMediaQuery = window.matchMedia('(min-width: 801px)');
      }

      if (!this.handleViewportChange) {
        this.handleViewportChange = () => this.repositionForViewport();
      }

      if (typeof this.desktopMediaQuery.addEventListener === 'function') {
        this.desktopMediaQuery.addEventListener('change', this.handleViewportChange);
      } else {
        this.desktopMediaQuery.addListener(this.handleViewportChange);
      }

      this.items = Array.from(this.querySelectorAll('.accordion'));
      this.handlers = new Map();

      this.renderRichTextContent();
      this.bindEvents();
      this.openFirst();
      this.repositionForViewport();
    }

    disconnectedCallback() {
      this.handlers.forEach((handler, titleEl) => {
        titleEl.removeEventListener('click', handler);
      });
      this.handlers.clear();

      if (this.desktopMediaQuery && this.handleViewportChange) {
        if (typeof this.desktopMediaQuery.removeEventListener === 'function') {
          this.desktopMediaQuery.removeEventListener('change', this.handleViewportChange);
        } else {
          this.desktopMediaQuery.removeListener(this.handleViewportChange);
        }
      }
    }

    repositionForViewport() {
      const shouldRelocate = this.desktopMediaQuery && this.desktopMediaQuery.matches;
      const complementary = document.querySelector('.complementary-products');

      if (shouldRelocate && complementary && complementary.parentNode) {
        if (this.parentNode !== complementary.parentNode || this.previousElementSibling !== complementary) {
          complementary.insertAdjacentElement('afterend', this);
        }

        if (this.sourceSectionWrapper) {
          this.sourceSectionWrapper.classList.add('is-accordion-relocated');
        }
        return;
      }

      if (this.sourceSectionWrapper) {
        this.sourceSectionWrapper.classList.remove('is-accordion-relocated');
      }

      if (this.originalPlacementMarker && this.originalPlacementMarker.parentNode) {
        if (this.originalPlacementMarker.nextSibling !== this) {
          this.originalPlacementMarker.parentNode.insertBefore(this, this.originalPlacementMarker.nextSibling);
        }
      }
    }

    bindEvents() {
      this.items.forEach((item) => {
        const titleEl = item.querySelector('.accordion-title');
        if (!titleEl) return;
        const handler = () => this.toggleItem(item);
        titleEl.addEventListener('click', handler);
        this.handlers.set(titleEl, handler);
      });
    }

    openFirst() {
      const first = this.items[0];
      if (!first) return;
      first.classList.add('open');
      const icon = first.querySelector('.accordion-icon');
      if (icon) icon.textContent = '-';
    }

    toggleItem(item) {
      const wasOpen = item.classList.contains('open');

      this.items.forEach((other) => {
        other.classList.remove('open');
        const icon = other.querySelector('.accordion-icon');
        if (icon) icon.textContent = '+';
      });

      if (!wasOpen) {
        item.classList.add('open');
        const icon = item.querySelector('.accordion-icon');
        if (icon) icon.textContent = '-';
        this.scrollIntoViewOnMobile(item);
      }
    }

    scrollIntoViewOnMobile(item) {
      if (window.innerWidth >= 768) return;
      const header = document.querySelector('[js-header="header"]');
      if (!header) return;
      const targetY = item.getBoundingClientRect().top + window.scrollY - header.offsetHeight - 10;
      window.scrollTo({ top: targetY, behavior: 'smooth' });
    }

    renderRichTextContent() {
      this.querySelectorAll('.accordion-content[data-content]').forEach((el) => {
        const raw = el.getAttribute('data-content');
        if (!raw) return;
        try {
          const parsed = JSON.parse(raw);
          el.innerHTML = this.richTextToHTML(parsed.children || []);
        } catch (e) {
          console.error('product-accordion: failed to parse rich text content', e);
        }
      });
    }

    richTextToHTML(nodes) {
      if (!nodes) return '';
      let html = '';
      nodes.forEach((node) => {
        switch (node.type) {
          case 'paragraph':
            html += '<p>' + this.richTextToHTML(node.children) + '</p>';
            break;
          case 'link':
            html += '<a href="' + node.url + '">' + this.richTextToHTML(node.children) + '</a>';
            break;
          case 'list':
            html += '<ul>' + this.richTextToHTML(node.children) + '</ul>';
            break;
          case 'list-item':
            html += '<li>' + this.richTextToHTML(node.children) + '</li>';
            break;
          case 'heading':
            html += '<h' + node.level + '>' + this.richTextToHTML(node.children) + '</h' + node.level + '>';
            break;
          case 'text':
            html += node.value;
            break;
          default:
            console.warn('product-accordion: unhandled node type', node.type);
        }
      });
      return html;
    }
  });

  document.addEventListener('shopify:section:unload', (event) => {
    if (!event.detail || String(event.detail.sectionId).indexOf('section-product-accordion') === -1) return;
    const section = event.target;
    document.querySelectorAll('product-accordion').forEach((el) => {
      if (!section.contains(el)) el.remove();
    });
  });
}
